function install(Vue) {
    Vue.prototype.recaptcha = function() {
        let captcha = new Promise((resolve, reject) => {
            const $script = document.createElement('script')
            $script.src = 'https://www.google.com/recaptcha/api.js?render=6LeVsQ4aAAAAACGJ1XXwRLP5M146uz15WClI6ZRf'
            resolve(document.head.appendChild($script));

            setTimeout(() => reject(new Error("Google reCaptcha не инициализирована")), 3000);
        });
        return new Promise((resolve, reject) => {
            captcha.then(
                result => {
                    setTimeout(() => {
                        grecaptcha.ready(() => {
                            grecaptcha.execute('6LeVsQ4aAAAAACGJ1XXwRLP5M146uz15WClI6ZRf', {action: 'homepage'}).then(token => {
                                resolve(token);

                            });
                        });
                    }, 200)
                });
            setTimeout(() => reject(new Error("Google reCaptcha не инициализирована")), 3000);
        });
    };
    Vue.prototype.buildFormData = function(formData, data, parentKey) {
        if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
            Object.keys(data).forEach(key => {
                this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
            });
        } else {
            const value = data == null ? '' : data;

            formData.append(parentKey, value);
        }
    };
    Vue.prototype.makeFormData = function(data) {
        const formData = new FormData();

        this.buildFormData(formData, data);

        return formData;
    };
}

export default install;
